module.exports = __webpack_public_path__ + "6d521de900ca601f5e8fb3dc654cbb0f.pdf";